@if (data?.title) {
  <h5 mat-dialog-title>{{data.title}}</h5>
}
<div mat-dialog-content>
  <div>{{data.text}}</div>
  <div>
    <form [formGroup]="labelForm" autocomplete="off">
      <div class="form-group">
        <input type="text" placeholder="Bookmark label" formControlName="label">
      </div>
    </form>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="" cdkFocusInitial class="btn btn-primary mr-auto">{{data.cancelText}}</button>
  <button mat-button [mat-dialog-close]="labelData()" [disabled]="!labelForm.valid" class="btn btn-success ml-auto">{{data.okText}}</button>
</div>
